"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { cn } from "../../../utils";
import type { VariantProps, SvgProps } from "../../color-block.types";
function SquareShapeSvg(t0) {
  const $ = _c(39);
  const {
    color,
    animated,
    shapeScale
  } = t0;
  let t1;
  if ($[0] !== animated || $[1] !== shapeScale) {
    t1 = origin => ({
      scale: animated ? shapeScale : 1,
      transformOrigin: origin
    });
    $[0] = animated;
    $[1] = shapeScale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  switch (color) {
    case "bright-blue":
      {
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#5375CF" />;
          $[3] = t2;
        } else {
          t2 = $[3];
        }
        let t3;
        if ($[4] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M382.133 97.8667C337.299 187.315 337.299 292.685 382.133 382.133C292.685 337.299 187.315 337.299 97.8667 382.133C142.701 292.685 142.701 187.315 97.8667 97.8667C187.315 142.701 292.685 142.701 382.133 97.8667Z" fill="#B8DBF7" style={style("center center")} /></svg>;
          $[4] = style;
          $[5] = t3;
        } else {
          t3 = $[5];
        }
        return t3;
      }
    case "light-green":
      {
        let t2;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#9BD7D2" />;
          $[6] = t2;
        } else {
          t2 = $[6];
        }
        let t3;
        if ($[7] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M240 76L76 240L240 404L404 240L240 76Z" fill="#00A399" style={style("center center")} /></svg>;
          $[7] = style;
          $[8] = t3;
        } else {
          t3 = $[8];
        }
        return t3;
      }
    case "turquoise":
      {
        let t2;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#00A399" />;
          $[9] = t2;
        } else {
          t2 = $[9];
        }
        let t3;
        if ($[10] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M376.667 376.667H103.333V239.983C103.333 164.497 164.532 103.333 239.982 103.333C315.433 103.333 376.667 164.532 376.667 239.983V376.667Z" fill="#407178" style={style("center center")} /></svg>;
          $[10] = style;
          $[11] = t3;
        } else {
          t3 = $[11];
        }
        return t3;
      }
    case "peach":
      {
        let t2;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#FF946A" />;
          $[12] = t2;
        } else {
          t2 = $[12];
        }
        let t3;
        if ($[13] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M256.965 376.667H103.333V223.055C103.298 156.93 156.902 103.333 223.036 103.333H376.667V256.945C376.667 323.07 323.063 376.667 256.929 376.667" fill="#AA4629" style={style("center center")} /></svg>;
          $[13] = style;
          $[14] = t3;
        } else {
          t3 = $[14];
        }
        return t3;
      }
    case "avocado":
      {
        let t2;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#C6E57D" />;
          $[15] = t2;
        } else {
          t2 = $[15];
        }
        let t3;
        if ($[16] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M376.667 308.333C376.667 346.073 346.073 376.666 308.334 376.667L171.667 376.666C133.927 376.666 103.334 346.073 103.334 308.333C103.334 270.889 133.451 240.478 170.784 240.005L171.667 240C133.927 240 103.334 209.406 103.334 171.666C103.334 133.927 133.927 103.333 171.667 103.333L308.334 103.333C346.073 103.334 376.666 133.927 376.667 171.667C376.667 209.406 346.073 240 308.334 240C346.073 240.001 376.667 270.594 376.667 308.333Z" fill="#9BD7D2" style={style("center center")} /></svg>;
          $[16] = style;
          $[17] = t3;
        } else {
          t3 = $[17];
        }
        return t3;
      }
    case "sky-blue":
      {
        let t2;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#90A8ED" />;
          $[18] = t2;
        } else {
          t2 = $[18];
        }
        let t3;
        if ($[19] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M382.133 97.8667C337.299 187.315 337.299 292.685 382.133 382.133C292.685 337.299 187.315 337.299 97.8666 382.133C142.701 292.685 142.701 187.315 97.8666 97.8667C187.315 142.701 292.685 142.701 382.133 97.8667Z" fill="#B280F4" style={style("center center")} /></svg>;
          $[19] = style;
          $[20] = t3;
        } else {
          t3 = $[20];
        }
        return t3;
      }
    case "orange":
      {
        let t2;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#EFAC53" />;
          $[21] = t2;
        } else {
          t2 = $[21];
        }
        let t3;
        if ($[22] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M376.667 308.333C376.667 346.073 346.073 376.666 308.334 376.667L171.667 376.666C133.927 376.666 103.334 346.073 103.334 308.333C103.334 270.889 133.451 240.478 170.784 240.005L171.667 240C133.927 240 103.334 209.406 103.334 171.666C103.334 133.927 133.927 103.333 171.667 103.333L308.334 103.333C346.073 103.334 376.666 133.927 376.667 171.667C376.667 209.406 346.073 240 308.334 240C346.073 240.001 376.667 270.594 376.667 308.333Z" fill="#AAF0C4" style={style("center center")} /></svg>;
          $[22] = style;
          $[23] = t3;
        } else {
          t3 = $[23];
        }
        return t3;
      }
    case "sea":
      {
        let t2;
        if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#008AAA" />;
          $[24] = t2;
        } else {
          t2 = $[24];
        }
        let t3;
        if ($[25] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M239.979 117.977L265.95 76L277.69 123.931L315.359 92.0474L311.728 141.287L357.378 122.58L338.712 168.272L387.91 164.598L356.027 202.268L404 214.007L362.023 239.979L404 265.95L356.027 277.69L387.91 315.359L338.712 311.728L357.378 357.42L311.728 338.713L315.359 387.953L277.69 356.069L265.95 404L239.979 362.023L214.007 404L202.268 356.069L164.598 387.953L168.272 338.713L122.58 357.42L141.245 311.728L92.0474 315.359L123.931 277.69L76 265.95L117.934 239.979L76 214.007L123.931 202.268L92.0474 164.598L141.245 168.272L122.58 122.58L168.272 141.287L164.598 92.0474L202.268 123.931L214.007 76L239.979 117.977Z" fill="#C6E57D" style={style("center center")} /></svg>;
          $[25] = style;
          $[26] = t3;
        } else {
          t3 = $[26];
        }
        return t3;
      }
    case "mint":
      {
        let t2;
        if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#68C187" />;
          $[27] = t2;
        } else {
          t2 = $[27];
        }
        let t3;
        if ($[28] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M239.662 154.78L283.623 75.6831L282.145 166.182L359.722 119.644L313.184 197.221L403.683 195.743L324.586 239.662L403.683 283.623L313.184 282.145L359.722 359.722L282.145 313.184L283.623 403.683L239.662 324.586L195.743 403.683L197.221 313.184L119.644 359.722L166.182 282.145L75.6829 283.623L154.78 239.662L75.6829 195.743L166.182 197.221L119.644 119.644L197.221 166.182L195.743 75.6831L239.662 154.78Z" fill="#D1E8BD" style={style("center center")} /></svg>;
          $[28] = style;
          $[29] = t3;
        } else {
          t3 = $[29];
        }
        return t3;
      }
    case "yellow":
      {
        let t2;
        if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#FFC627" />;
          $[30] = t2;
        } else {
          t2 = $[30];
        }
        let t3;
        if ($[31] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M256.965 376.667H103.333V223.055C103.298 156.93 156.902 103.333 223.035 103.333H376.667V256.945C376.667 323.07 323.063 376.667 256.929 376.667" fill="#FF946A" style={style("center center")} /></svg>;
          $[31] = style;
          $[32] = t3;
        } else {
          t3 = $[32];
        }
        return t3;
      }
    case "cobalt":
      {
        let t2;
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#3B72FF" />;
          $[33] = t2;
        } else {
          t2 = $[33];
        }
        let t3;
        if ($[34] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M286.869 376.667H193.096C143.517 376.667 103.333 336.478 103.333 286.893V193.107C103.333 143.522 143.552 103.333 193.131 103.333H286.905C336.483 103.333 376.667 143.522 376.667 193.107V286.893C376.667 336.478 336.483 376.667 286.905 376.667" fill="#0047BB" style={style("center center")} /></svg>;
          $[34] = style;
          $[35] = t3;
        } else {
          t3 = $[35];
        }
        return t3;
      }
    case "ocean":
      {
        let t2;
        if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = <rect width="480" height="480" fill="#1A3C82" />;
          $[36] = t2;
        } else {
          t2 = $[36];
        }
        let t3;
        if ($[37] !== style) {
          t3 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 480 480" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t2}<motion.path d="M376.667 103.333C376.667 126.213 368.453 147.472 354.381 165.12C367.733 166.772 376.667 177.779 376.667 191.575V287.673C376.667 301.47 367.733 313.228 354.381 314.879C368.453 332.528 376.667 353.787 376.667 376.667L103.333 376.667C103.333 353.707 111.604 332.38 125.766 314.694C113.027 312.507 103.333 301.41 103.333 288.049V191.951C103.333 178.59 113.027 167.493 125.766 165.305C111.604 147.62 103.333 126.293 103.333 103.333H376.667Z" fill="#008AAA" style={style("center center")} /></svg>;
          $[37] = style;
          $[38] = t3;
        } else {
          t3 = $[38];
        }
        return t3;
      }
    default:
      {
        return null;
      }
  }
}
const SquareShapeColorBlock = React.forwardRef<HTMLDivElement, VariantProps>((t0, ref) => {
  const $ = _c(26);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      color: t1,
      animated: t2,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const color = t1 === undefined ? "bright-blue" : t1;
  const animated = t2 === undefined ? true : t2;
  const containerRef = useRef(null);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      target: containerRef,
      offset: ["start end", "end start"]
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    scrollYProgress
  } = useScroll(t3);
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    t5 = [1, 1.3];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const shapeScale = useTransform(scrollYProgress, t4, t5);
  let t6;
  if ($[9] !== ref) {
    t6 = node => {
      (containerRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
      if (typeof ref === "function") {
        ref(node);
      } else {
        if (ref) {
          ref.current = node;
        }
      }
    };
    $[9] = ref;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = !children && "aspect-square";
  let t8;
  if ($[11] !== className || $[12] !== t7) {
    t8 = cn("relative overflow-hidden", t7, className);
    $[11] = className;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== animated || $[15] !== color || $[16] !== shapeScale) {
    t9 = <SquareShapeSvg color={color} animated={animated} shapeScale={shapeScale} />;
    $[14] = animated;
    $[15] = color;
    $[16] = shapeScale;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== children) {
    t10 = children && <div className="relative z-10">{children}</div>;
    $[18] = children;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== props || $[21] !== t10 || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div ref={t6} data-slot="color-block" className={t8} {...props}>{t9}{t10}</div>;
    $[20] = props;
    $[21] = t10;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
});
SquareShapeColorBlock.displayName = "SquareShapeColorBlock";
export { SquareShapeColorBlock };